<app-page-header
  class="header"
  coreActivitySection="Header"
  [coreUserActivityClickTracking]="'Close' + menu().name.split(' ').join('')"
  backButtonText="Back"
  [backSwipe]="backSwipeConfig"
  (click)="back.emit()"
>
  <div class="title">{{ menu().name }}</div>
  <div class="table">Table {{ tableName() }}</div>
</app-page-header>

<div class="pages">
  @for (url of menu().pagesLocal; track url) {
    <core-menu-image [url]="url"/>
  }
</div>
